'use strict';

const moment = require('moment');

module.exports = ['$scope', '$http', '$sce', '$timeout', function ($scope, $http, $sce, $timeout) {
    let plantIds = 'all';

    function getUrl(queryParams, suffix='') {
        const date = moment($scope.reportConfig.date, $scope.$root.dateFormat.moment).format('YYYY-MM-DD');
        const sortOrder = ($scope && $scope.reportSortOrder && $scope.reportSortOrder.value) || DEFAULT_SORT_ORDER;
        const params = Object.entries(Object.assign({sorting: sortOrder}, queryParams));
        const queryString = params.length === 0 ? '' :  '?' + params.map(([key, value]) => `${key}=${encodeURIComponent(value)}`).join('&');

        return `/plant/${plantIds}/day_report/${date}/${suffix}${queryString}`;
    }

    function optionField(label, value) {
      return {
        text: label,
        value: value,
      }
    }

    const DEFAULT_SORT_ORDER = optionField('Material', 'material');

    function fieldList(customFields) {
      const _customFields = customFields || [];
      return [
        optionField('Customer', 'customer'),
        optionField('Quantity', 'quantity'),
        optionField('Load Time', 'load_time'),
        DEFAULT_SORT_ORDER,
      ].concat(_customFields.map((fieldName) => {
        return optionField(fieldName, `X_${fieldName}`);
      }));
    }


    //
    //  Scope Fns
    //
    $scope.getReportUrl = getUrl;

    $scope.refreshData = function () {
        $http.get(getUrl({}, 'json/'), {}).success(function (data) {
            $scope.reportConfig.data = data;
            $scope.reportConfig.customFields = fieldList(uniqueReportColumns(data));
        });
    };

    $scope.sendReport = function () {
        if ($scope.sending) {
            return;
        }
        $scope.sending = true;
        $scope.sent = false;

        delete $scope.error;

        const url = getUrl({to: $scope.reportConfig.to});
        $http.post(url).success(function (data) {
            $scope.sending = false;
            $scope.sent = true;

            $timeout(function () {
                $scope.sent = false;
            }, 3000);

        }).error(function (data) {
            $scope.sending = false;
            $scope.error = data;
            console.log('Send Report Error', data);
        });
    };

    $scope.getOrderDates = function (report) {
      const materialIdMap = report.materials.reduce((acc, material) => {
        acc[material.id] = material;
        return acc;
      }, {});

      const orderDates = report.periods[0].order_dates;
      return orderDates.map((orderDate) => {
        return Object.assign(orderDate, {
          material: materialIdMap[orderDate.order.material],
        })
      });
    };

    $scope.parseCustomsFieldData = function (data) {
        const result = {};
        data.forEach(function (item) {
            result[item.key] = item.value
        });
        return result;
    };

    //
    //  Watch
    //
    $scope.$watch('reportConfig.date', function (newDate, oldDate) {
        if (newDate !== oldDate) {
            $scope.refreshData();
        }
    });

    $scope.$watch('reportConfig.to', function (newDate, oldDate) {
        if (newDate !== oldDate) {
            $scope.sent = false;
        }
    });

    $scope.$watchCollection('selectedPlants', function (selectedPlants, oldPlants) {
        if (selectedPlants.length === 0) {
          plantIds = 'all';
        } else {
          plantIds = selectedPlants.join('+');
        }
        $scope.refreshData();
    });

    $scope.$watch('reportSortOrder', function (newSortOrder) {
      if (!newSortOrder) {
        $scope.reportSortOrder = DEFAULT_SORT_ORDER;
      }
      $scope.refreshData();
    });

    // ------------------
    // Initialization
    // ------------------
    //$scope.data = $scope.data || {};

    $scope.toOptions = {
        me: 'Me',
        org: 'My Organization'
    };

    $scope.reportConfig = {
        date: moment().format($scope.$root.dateFormat.moment),
        to: 'me',
        customFields : fieldList(),
    };

    $scope.sending = false;

    $scope.sent = false;

    $scope.reportSortOrder = DEFAULT_SORT_ORDER;
}];

function uniqueReportColumns (reports=[], index=0,uniqueReports){
    if(!reports[index]) return uniqueReports || [];
    if(!reports[index].materials.length) return uniqueReportColumns(reports,++index,uniqueReports);
    if(!uniqueReports){
        if(reports[index].order_fields && reports[index].order_fields.length){
            uniqueReports = reports[index].order_fields.map((item={})=>item.name);
        }
        return uniqueReportColumns(reports,++index,uniqueReports);
    }
    const tempSet = new Set(reports[index].order_fields.map((item={})=>item.name.toUpperCase()));
    return uniqueReportColumns (reports, ++index, uniqueReports.filter(item=> tempSet.has(item.toUpperCase())))
}
